import { useEffect } from "react";
import CardCQW from "../../../../../CardCQW/component";
import { CardVariantsEnum } from "../../../../../../utils/dataTransform/ContentQueryWidget/types";

const Playlist = ({
    items = [],
    itemSelectionCallback = () => {},
    selectedId = null,
    playlistTitle = "",
    featureAttributionData = {},
}) => {
    useEffect(() => {
        if (!items.length) return;
        const featureAttribution = getFeatureAttribution(
            0,
            featureAttributionData
        );
        itemSelectionCallback(items[0], false, featureAttribution);
    }, [items[0]?.sourceId]);

    if (!items.length) return;

    const selectedItemId = () => {
        return selectedId === null ? items[0].sourceId : selectedId;
    };

    const isSelected = (id) => {
        return selectedItemId() === id;
    };

    const formattedPlaylistTitle = () => {
        return playlistTitle === "" ? playlistTitle : `${playlistTitle} - `;
    };

    const getFeatureAttribution = (index, featureAttributionData) => {
        if (!featureAttributionData?.instance) return null;

        return {
            instance: featureAttributionData.instance,
            name: "media-playlist-player",
            position: index + 1,
        };
    };

    return (
        <div className="playlist">
            <h3>
                {formattedPlaylistTitle()}
                <span>{items.length} videos</span>
            </h3>
            <div className="playlist-inner">
                <ul>
                    {items.map((item, index) => {
                        const featureAttribution = getFeatureAttribution(
                            index,
                            featureAttributionData
                        );
                        return (
                            <li
                                key={item.id + "-" + index}
                                className={`playlist-item ${
                                    isSelected(item.sourceId) ? "active" : ""
                                }`}
                                data-testid="playlist-item"
                            >
                                <CardCQW
                                    {...item}
                                    variant={CardVariantsEnum.HORIZONTAL}
                                    clickHandler={(event) =>
                                        itemSelectionCallback(
                                            item,
                                            true,
                                            featureAttribution,
                                            event
                                        )
                                    }
                                    featureAttribution={featureAttribution}
                                />
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default Playlist;
